import React from 'react';
import { DashboardIcon } from '@esgian/esgianui';
import DescriptionIcon from '@mui/icons-material/Description';
import { setSideMenuItemOpen } from '@store/features';

export const getSideMenuList = (routeChange, sideMenuOpen, dropDownMenuOpen, dispatch) => {
  return [
    {
      key: 'dashboard',
      id: 'dashboard',
      icon: <DashboardIcon color={'inherit'} />,
      text: 'Dashboard',
      path: '/greenpact-live',
      onClick: () => {
        routeChange('/greenpact-live');
      }
    },
    {
      key: 'reports',
      id: 'reports',
      icon: <DescriptionIcon color={'inherit'} />,
      text: 'Reports',
      path: '/reports',
      onClick: () => {
        routeChange('/reports');
      }
    }
  ];
};
